// extracted by mini-css-extract-plugin
export default {"header":"emailAlerts_header__nOL-+"};